import type { ComponentStyleConfig } from '@chakra-ui/react';

import { small } from '../typography';

const FormErrorComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    text: {
      ...small,
      color: 'error400',
    },
  },
};

export default FormErrorComponentStyle;
